import React, { useEffect, useMemo, useRef } from 'react';
import { useRestaurants } from '../../hooks/useRestaurants.js';

export const RestaurantsSelectView = ({
  items,
  loading,
  error,
  selected,
  disabled,
  isSingle,
  onChange,
  pendingDispatch
}) => {
  const selectRef = useRef(null);

  useEffect(() => {
    if (!selectRef.current || !pendingDispatch) {
      return;
    }
    if (pendingDispatch.current && selected) {
      const event = new Event('change', { bubbles: true });
      selectRef.current.dispatchEvent(event);
      pendingDispatch.current = false;
    }
  }, [selected, pendingDispatch]);

  const options = useMemo(() => {
    if (loading) {
      return [<option key="loading">Cargando sucursales...</option>];
    }
    if (error) {
      return [<option key="error" value="">{error}</option>];
    }
    if (items.length === 0) {
      return [<option key="empty" value="">No tiene sucursales asignadas</option>];
    }
    if (!isSingle) {
      return [
        <option value="" key="placeholder">
          Seleccione un restaurante
        </option>,
        ...items.map(({ value, label }) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))
      ];
    }
    return items.map(({ value, label }) => (
      <option value={value} key={value}>
        {label}
      </option>
    ));
  }, [items, loading, error, isSingle]);

  const handleChange = (event) => {
    onChange?.(event.target.value);
  };

  return (
    <>
      <select
        id="restaurante-select"
        className="form-select"
        ref={selectRef}
        value={selected}
        onChange={handleChange}
        disabled={disabled || loading || (isSingle && !!selected)}
      >
        {options}
      </select>
      {!loading && error && (
        <p className="form-error" role="alert">
          {error}
        </p>
      )}
    </>
  );
};

const RestaurantsSelect = () => {
  const state = useRestaurants();
  return (
    <RestaurantsSelectView
      items={state.items}
      loading={state.loading}
      error={state.error}
      selected={state.selected}
      disabled={state.disabled}
      isSingle={state.isSingle}
      onChange={state.setSelected}
      pendingDispatch={state.pendingDispatch}
    />
  );
};

export default RestaurantsSelect;
